import { css } from '@emotion/react';
import { Theme } from '@shipengine/giger-theme';
import { scope } from '../../providers/GigerProvider/useTheme.js';
import { IconSize } from './types/size.js';

const getIconSizeStyles = (size, theme) => {
  switch (size) {
    case IconSize.SIZE_SMALL:
      return {
        height: theme.iconSize.small,
        width: theme.iconSize.small
      };
    case IconSize.SIZE_MEDIUM:
      return {
        height: theme.iconSize.medium,
        width: theme.iconSize.medium
      };
    case IconSize.SIZE_REGULAR:
      return {
        height: theme.iconSize.regular,
        width: theme.iconSize.regular
      };
    case IconSize.SIZE_LARGE:
      return {
        height: theme.iconSize.large,
        width: theme.iconSize.large
      };
    case IconSize.SIZE_EXTRA_LARGE:
      return {
        height: theme.iconSize.extra_large,
        width: theme.iconSize.extra_large
      };
    default:
      return {};
  }
};
const fallbackTheme = new Theme();
const getIconStyles = size => scope(providedTheme => {
  const theme = isThemeActive(providedTheme) ? providedTheme : fallbackTheme;
  return /*#__PURE__*/css({
    display: 'inline-flex',
    svg: {
      fill: 'currentColor',
      ...getIconSizeStyles(size, theme)
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
});

// Heuristic to ensure theme is active
function isThemeActive(theme) {
  return !!theme.iconSize;
}

export { getIconStyles };
//# sourceMappingURL=IconStyles.js.map
